/**
 * Service Worker registration — SBC Ltd Brewing PWA.
 * Runs only in production/preview (over HTTPS or localhost).
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register("/service-worker.js", { scope: "/" });

      // Auto-apply new SW when one becomes available
      registration.addEventListener("updatefound", () => {
        const worker = registration.installing;
        if (!worker) return;
        worker.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) {
            worker.postMessage({ type: "SKIP_WAITING" });
          }
        });
      });

      // Reload once the new SW takes control (only if a controller existed before)
      let refreshed = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshed) return;
        refreshed = true;
        // Only reload if this wasn't the first-ever registration
        if (document.visibilityState === "visible") window.location.reload();
      });
    } catch (err) {
      // Silent — SW is progressive enhancement.
      console.warn("[SBC PWA] Service worker registration failed:", err);
    }
  });
}
